var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('ModalOptionsToggleButton',{attrs:{"text":_vm.text},model:{value:(_vm.setting),callback:function ($$v) {_vm.setting=$$v},expression:"setting"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }